import type { ReactNode } from "react";

import { ColorPicker } from "@/react/components/SettingsApp/CompassCompat/ColorPicker";
import { useIsCircleV4FeatureEnabled } from "@/react/hooks/useIsCircleV4FeatureEnabled";

import { FormColorPickerV1 } from "./FormColorPickerV1";

export const isHexColor = (color = "") =>
  /(^#[0-9A-F]{6}$)|(^#[0-9A-F]{3}$)/i.test(color);

export interface FormColorPickerProps {
  description?: ReactNode;
  disabled?: boolean;
  error?: string;
  id?: string;
  invalid?: boolean;
  label?: ReactNode;
  labelTooltip?: string;
  layout?: "horizontal" | "vertical";
  name: string;
  rootProps?: Record<string, unknown>;
  supportTransparency?: boolean;
}

export const FormColorPicker = ({
  name,
  disabled = false,
  id,
  supportTransparency = false,
  label,
  description,
  error,
  invalid,
  layout,
  labelTooltip,
  rootProps,
}: FormColorPickerProps) => {
  const isV4 = useIsCircleV4FeatureEnabled("circle_v4_form_elements_enabled");

  if (isV4) {
    return (
      <ColorPicker
        name={name}
        disabled={disabled}
        supportTransparency={supportTransparency}
        label={label}
        description={description}
        error={error}
        invalid={invalid}
        layout={layout}
        labelTooltip={labelTooltip}
        rootProps={rootProps}
      />
    );
  }

  return <FormColorPickerV1 name={name} disabled={disabled} id={id} />;
};

FormColorPicker.displayName = "Form.ColorPicker";
